module.exports = {"id":"dp3_1l1q5","text":"Developing digital content","instructions":"How confident are you using basic features of content creation tools?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.1","questionType":"Scale","random":false,"options":[{"id":"dp3_1l1q5-a1","text":"Very unconfident","score":0},{"id":"dp3_1l1q5-a2","text":"Somewhat unconfident","score":0.4},{"id":"dp3_1l1q5-a3","text":"Neutral","score":1},{"id":"dp3_1l1q5-a4","text":"Somewhat confident","score":1.6},{"id":"dp3_1l1q5-a5","text":"Very confident","score":2}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.1/l1q5.json
// module id = 1114
// module chunks = 41